import { ButtonLink } from '../../components/Form/Button';
import { Loader } from '../../components/Loader/Loader';
import { useConfig } from '../../config';
import { useFormatting, useTranslation } from '../../i18n/i18n';
import { useCart } from '../../state/cart';
import { UiContainer } from '../../state/ui';
import { useDefaultVatMultiplier } from '../../utils/vatUtils';
import { empty, Icon, thumbs_up } from '../Icon/Icon';
import { ProgressBar } from './ProgressBar/ProgressBar';

const calculateLeftToFreeShipping = (limit: number, subtotal: number) => {
	return Math.floor(Math.max(0, limit - subtotal));
};

const calculateProgress = (freeShippingLimit: number, leftToFreeShipping: number) => {
	return Math.round((100.0 * (freeShippingLimit - leftToFreeShipping)) / freeShippingLimit);
};

const FreeShippingProgressBar = (): JSX.Element => {
	const { cart } = useCart();
	const totals = cart.totals;

	const { freeShippingLimit, currencyCode } = useConfig();
	const t = useTranslation().cart;
	const ui = UiContainer.useContainer();
	const { asPrice } = useFormatting();
	const vatMultiplier = useDefaultVatMultiplier(ui.priceWithVat);

	if (!totals) return <Loader />;

	const leftToFreeShipping = calculateLeftToFreeShipping(freeShippingLimit, totals.freeFreightEligibleSubTotal);
	const progress = calculateProgress(freeShippingLimit, leftToFreeShipping);

	return (
		<>
			<div>
				<ProgressBar progress={progress} />
				<p>
					{leftToFreeShipping !== 0 ? (
						<>
							<span className="left-to-free-shipping">{t.only}</span>
							<span className="amount-left-to-free-shipping">
								{asPrice(
									leftToFreeShipping * vatMultiplier,
									currencyCode === 'EUR' ? 2 : 0,
									currencyCode !== 'EUR'
								)}
							</span>{' '}
							<span className="left-to-free-shipping">{t.amountLeftToFreeShipping}</span>{' '}
							<Icon shape={empty} />
						</>
					) : (
						<>
							{t.freeShippingAchieved} <Icon shape={thumbs_up} />
						</>
					)}
				</p>
			</div>
		</>
	);
};

export const CartFooter = (): JSX.Element => {
	const ui = UiContainer.useContainer();
	const { cart } = useCart();
	const t = useTranslation().cart;
	const tRoutes = useTranslation().routes;

	return (
		<div id="to-checkout-footer">
			<FreeShippingProgressBar />
			<ButtonLink
				linkTo={tRoutes.checkout}
				className="big"
				disabled={cart.items.length === 0}
				onClick={ui.toggleCart}
			>
				{t.checkout}
			</ButtonLink>
		</div>
	);
};
